import { useRouter } from 'next/router';
import {
  Bar,
  ComposedChart,
  LabelList,
  Line,
  ResponsiveContainer,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from './Recharts.styled';

const ApplicationsWeekly: React.FC = () => {
  const { locale } = useRouter();

  const GRAPH_11_WEEKLY_APPLICATIONS = [
    { label: locale === 'es' ? 'Lun' : 'Mon', value: 18 },
    { label: locale === 'es' ? 'Mar' : 'Tue', value: 18 },
    { label: locale === 'es' ? 'Mie' : 'Wed', value: 17 },
    { label: locale === 'es' ? 'Jue' : 'Thu', value: 17 },
    { label: locale === 'es' ? 'Vie' : 'Fri', value: 15 },
    { label: locale === 'es' ? 'Sab' : 'Sat', value: 9 },
    { label: locale === 'es' ? 'Dom' : 'Sun', value: 7 }
  ];

  return (
    <div>
      <StyledRecharts className="applications">
        <ResponsiveContainer width="99%" height={140}>
          <ComposedChart
            data={GRAPH_11_WEEKLY_APPLICATIONS}
            margin={{ left: 50, right: 50 }}
          >
            <XAxis
              type="category"
              allowDecimals={false}
              dataKey="label"
              interval={0}
              tickLine={false}
            />
            <YAxis type="number" hide={true} />

            <Bar
              dataKey="value"
              isAnimationActive={false}
              fill="#28CEBC"
              barSize={52}
            >
              <LabelList
                dataKey="value"
                formatter={(value: number) => [value + '%']}
                position="insideBottom"
              />
            </Bar>
            <Line
              dataKey="value"
              type="monotone"
              dot={false}
              stroke="#84F6D6"
              strokeWidth={2}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default ApplicationsWeekly;
